import React, { useState } from "react";
import SharedHelmet from "../.././Helmet";
import imgUrl from "../../../../images/age-year.webp"
const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const TITLE = `حساب عمر مواليد السنوات من 1960 إلى ${currentYear} | دقة متناهية`;
const DESCRIPTION = `احسب عمرك الآن بدقة عالية إذا كنت من مواليد أي سنة بين 1960 و${currentYear}. حاسبة عمر مفصلة تُظهر لك عدد السنوات والأشهر والأيام منذ تاريخ ميلادك حتى اليوم. مناسبة لمواليد الستينات والسبعينات والثمانينات والتسعينات والألفينات حتى ${currentYear}.`;
const KEYWORDS = `
حاسبة عمر,
حساب العمر,
كم عمري الآن,
عمر مواليد 1960,
عمر مواليد 1970,
عمر مواليد 1980,
عمر مواليد 1990,
عمر مواليد 2000,
عمر مواليد 2010,
مواليد 1960 كم عمرهم,
مواليد 1970 كم عمرهم,
مواليد 1980 كم عمرهم,
مواليد 1990 كم عمرهم,
مواليد 2000 كم عمرهم,
مواليد 2010 كم عمرهم,
كم عمر مواليد 1960,
كم عمر مواليد 1970,
كم عمر مواليد 1980,
كم عمر مواليد 1990,
كم عمر مواليد 2000,
كم عمر مواليد 2010,
حساب العمر بالسنوات والأشهر والأيام,
عمر مواليد من 1960 إلى ${currentYear}
`.trim();
const OG_URL = "https://do-calculate.com/calculator/ar/gregorian/gregorian-year-list/";
function GregorianYearsList() {
    const [searchTerm, setSearchTerm] = useState("");
    const years = Array.from({ length: currentYear - 1960 + 1 }, (_, i) => 1960 + i);
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const filteredYears = years.filter(year =>
        year.toString().includes(searchTerm)
    );
    return (
        <div className="container rtl-container">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                OG_IMAGE={imgUrl}
            />
            <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
            <hr />
            <div className="alert alert-secondary" role="alert">
                <p>{DESCRIPTION}</p>
            </div>
            <hr />
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingBottom: "15px",
                }}
            >
                <h2 style={{ margin: 0 }}>البحث عن سنة الميلاد</h2>
                <input
                    type="text"
                    placeholder="ابحث عن سنة..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        width: "200px",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    }}
                />
            </div>
            <table className="bmi-table" style={{ width: "100%", tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th >سنة الميلاد</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredYears.map((year, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    <a href={`/calculator/ar/gregorian/${year}/`}>
                                        مواليد سنة {year}
                                    </a>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="mt-4 p-3 bg-light rounded">
                <h3>كيفية استخدام الحاسبة:</h3>
                <ul>
                    <li>اختر سنة الميلاد من الجدول أعلاه</li>
                    <li>ستنتقل إلى صفحة الحاسبة الخاصة بتلك السنة</li>
                    <li>أدخل يوم وشهر الميلاد لمعرفة عمرك بالضبط</li>
                </ul>
            </div>
        </div>
    );
}
export default GregorianYearsList;